<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { BlockContainer, PrivacyShield } from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'
import { useSessionStore } from '../../stores/session'
import ConsentWrapper from '../consent/ConsentWrapper.vue'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'iframe')

const sessionStore = useSessionStore()
const { t } = useI18n()

const pageStore = usePageStore()
const isStructureOrAuthor = computed(() => pageStore.pageData.pageMeta.pageType === 'structureterm' || pageStore.pageData.pageMeta.structureTermType === 'author')

const size = computed(() => {
  return isStructureOrAuthor.value ? 'full' : 'normal'
})

const simulateContentPassOrContentPass = computed(() => sessionStore.simulateContentPassOrContentPass)

const headline = computed(() => t(`privacyShield.iframe.headline.${simulateContentPassOrContentPass.value ? 'withPurSub' : 'withoutPurSub'}`))

const description = computed(() => simulateContentPassOrContentPass.value ? t('privacyShield.iframe.description.withPurSub') : [t('privacyShield.iframe.description.withoutPurSub')])
</script>

<template>
  <BlockContainer data-testid="embed-container"
                  :size="size"
                  class="pt-3 md:pt-4 pb-6 md:pb-8 gap-3">
    <ConsentWrapper vendor="iframe"
                    :vendor-id="contentBlock.data.iframe.consentVendorId"
                    :simulate-content-pass-or-content-pass="simulateContentPassOrContentPass">
      <template #enabled>
        <div class="w-full flex justify-center">
          <iframe
            :src="contentBlock.data.iframe.url"
            class="w-[320px] md:w-[900px] h-[512px]"
            :style="{
              ...(contentBlock.data.iframe.height ? { height: `${contentBlock.data.iframe.height}px` } : {}),
              ...(contentBlock.data.iframe.width ? { width: `${contentBlock.data.iframe.width}px` } : {})
            }"
            allowfullscreen />
        </div>
      </template>
      <template #disabled="{ onConsentClick }">
        <div class="w-full flex justify-center">
          <div class="relative">
            <PrivacyShield
              embed-type="iframe"
              :simulate-content-pass-or-content-pass="simulateContentPassOrContentPass"
              :headline="headline"
              :description="description"
              :consent-button-text="t('privacyShield.buttons.iframe.consent')"
              :privacy-policy-button-text="t('privacyShield.buttons.privacyPolicy')"
              @consent-click="onConsentClick" />
          </div>
        </div>
      </template>
    </ConsentWrapper>
  </BlockContainer>
</template>
